import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { BasePage } from '../../base.page';
import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import {
    ClientInterface,
    ContractInterface,
    GetAppropriatenessClientUseCase,
    GetContractUseCase,
    UpdateValidationUseCase,
    ValidateContractOnlyUseCase,
    ValidationStatus,
} from '../../../../core';
import { MainRoutes } from '../../../main-routes.enum';
import { Id } from '../../../domain/data';
import { ParentEvents } from '../../../utils/parent-events.service';
import { TestPage } from '../test.page';

@Component({
    templateUrl: './test-result-suitability.page.html',
    styleUrls: ['./test-result-suitability.page.scss'],
})
export class TestResultSuitabilityPage extends BasePage implements AfterViewInit, OnInit {
    public static PROFILE_NOT_COMPATIBLE = Id.fromString('7');
    public profileName: string;

    constructor(
        parentEvents: ParentEvents,
        protected testPage: TestPage,
        protected dialog: MatDialog,
        protected getAppropriatenessClientUseCase: GetAppropriatenessClientUseCase,
        protected getContractUseCase: GetContractUseCase,
        protected router: Router,
        protected updateValidationUseCase: UpdateValidationUseCase,
        protected validateContractOnlyUseCase: ValidateContractOnlyUseCase
    ) {
        super(parentEvents);
        testPage.hideBackButton();
    }

    get contract(): ContractInterface {
        return this.testPage.contract;
    }

    ngOnInit(): void {
        this.getProfileName();
    }

    protected getProfileName(): void {
        this.getAppropriatenessClientUseCase.bind().subscribe((transaction) => {
            transaction.fold(
                (client) => {
                    this.profileName = client.profileName;
                    this.checkCompatibility(client);
                },
                (err) =>
                    this.dialog.open(ErrorDialog, {
                        data: { text: err.message },
                    })
            );
        });
    }

    protected checkCompatibility(client: ClientInterface): void {
        if (client.profileId.equals(TestResultSuitabilityPage.PROFILE_NOT_COMPATIBLE)) {
            this.getContractUseCase.bind().subscribe((transaction) => {
                let dialogRef: MatDialogRef<any>;

                transaction.fold(
                    (contract) => {
                        if (contract.isAdvisoryModelGDC()) {
                            dialogRef = this.dialog.open(ErrorDialog, {
                                data: {
                                    type: 'info',
                                    text: 'dialog.test-cannot-continue-gdc',
                                },
                            });
                        } else {
                            dialogRef = this.dialog.open(ErrorDialog, {
                                data: {
                                    type: 'info',
                                    text: 'dialog.test-cannot-continue',
                                },
                            });
                        }
                    },
                    () => {
                        dialogRef = this.dialog.open(ErrorDialog, {
                            data: {
                                type: 'info',
                                text: 'dialog.test-cannot-continue',
                            },
                        });
                    }
                );

                dialogRef?.afterClosed().subscribe(() => {
                    this.parentEvents.cancel();
                });
            });
        }
    }

    onClick(): void {
        this.getContractUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                if (transaction.data.isAdvisoryModelGDC()) {
                    this.router.navigateByUrl(MainRoutes.TEST_TRANSFER);
                } else {
                    transaction.data.validation.status = ValidationStatus.VALID;

                    this.updateValidationUseCase.bind({ contract: transaction.data }).subscribe((updateTransaction) => {
                        if (updateTransaction.isSuccess) {
                            this.validateContractOnlyUseCase.bind().subscribe((validateTransaction) => {
                                if (validateTransaction.isSuccess) {
                                    this.parentEvents.cancel();
                                } else if (!validateTransaction.isAuthError) {
                                    this.dialog.open(ErrorDialog, {
                                        data: {
                                            text: validateTransaction.error,
                                        },
                                    });
                                }
                            });
                        } else if (!updateTransaction.isAuthError) {
                            this.dialog.open(ErrorDialog);
                        }
                    });
                }
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
        });
    }
}
